<template>
  <CContainer class="px-4 px-lg-5">
    <CRow>
      <CCol>
        <CCard class="bg-style2">
          <CCardHeader class="bg-gradient-dark text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
            <span class="font-weight-bold h6"> SET TIME </span>

            <div class="card-header-actions">
            </div>
          </CCardHeader>
          <CCardBody>
            <CRow class="mb-3">
              <CCol col="3">
                <label class="font-weight-bold">Event</label>
              </CCol>
              <CCol>
                <select class="form-control" v-model="selectedEvent" @change="onEventChange">
                  <option value="">Select Event</option>
                  <option v-for="evt in events" :key="evt._id" :value="evt.event_name">{{ evt.event_name }}</option>
                </select>
              </CCol>
            </CRow>

        <!-- Candidate Type Dropdown -->
            <CRow class="mb-3">
              <CCol col="3">
                <label class="font-weight-bold">Candidate Type</label>
              </CCol>
              <CCol>
                <select class="form-control" v-model="selectedCandidateType" @change="onTypeChange">
                  <option value="">Select Candidate Type</option>
                  <option v-for="type in types" :key="type._id" :value="type.type_name">{{ type.type_name }}</option>
                </select>
              </CCol>
            </CRow>

            <!-- Start and End Date -->
            <CRow class="mb-3">
              <CCol col="3">
                <label class="font-weight-bold">Start Date</label>
              </CCol>
              <CCol>
                <CInput type="datetime-local" v-model="startDate" :min="minDate" />
              </CCol>
                <label class="mt-2">-</label>
              <CCol>
                <CInput
                    type="datetime-local"
                    v-model="endDate"
                    :min="startDate || minDate"
                    :disabled="!startDate"
                />

              </CCol>
            </CRow>

            <CRow class="mt-4 float-right">
              <CCol>
                <CButton color="success" variant="outline" shape="pill" @click="onSetTime">
                  <samp class="pl-2 pr-2">SET TIME</samp>
                </CButton>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <SetterList/>
  </CContainer>
</template>

<script>
import api from "@/service/api.js";
import Swal from "sweetalert2";
import SetterList from '@/projects/views/admin/component/history_settime.vue'

export default {
  components: { SetterList },
  data() {
    return {
      types: [],
      events: [],
      selectedCandidateType: "",
      selectedEvent: "",
      startDate: "",
      endDate: "",
      minDate: ""
    };
  },
  mounted() {
    this.setMinDate()
    this.fetchTypes();
    this.fetchEvents();
  },
  methods: {
    setMinDate() {
      const now = new Date()
      const tzOffset = now.getTimezoneOffset() * 60000 // ms
      const localISOTime = new Date(now - tzOffset).toISOString().slice(0, 16)
      this.minDate = localISOTime
    },
    async fetchTypes() {
      try {
        const { data } = await api.type("get");
        this.types = data.data || [];
      } catch (err) {
        console.error("Error fetching types:", err);
      }
    },
    async fetchEvents() {
      try {
        const { data } = await api.event("get");
        this.events = data.data || [];
      } catch (err) {
        console.error("Error fetching events:", err);
      }
    },
    onTypeChange() {
      console.log("Type:", this.selectedCandidateType);
    },
    onEventChange() {
      console.log("Event:", this.selectedEvent);
    },
    async onSetTime() {
      if (!this.selectedEvent || !this.selectedCandidateType) {
        return Swal.fire("Missing Info", "Please select both event and candidate type.", "warning");
      }

      if (!this.startDate) {
        return Swal.fire("Missing Info", "Please select a start date before setting the end date.", "warning");
      }

      if (!this.endDate) {
        return Swal.fire("Missing Info", "Please select an end date.", "warning");
      }

      if (this.endDate <= this.startDate) {
        return Swal.fire("Invalid Date", "End date must be later than start date.", "error");
      }

      if (this.selectedEvent === "Result") {
        try {
          const setterRes = await api.setter("get");
          const setters = setterRes.data.data || [];

          // Find VOTE event with same type that is still open
          const voteStillOpen = setters.find(s =>
              (s.title?.event_name || s.title) === "Vote" &&
              (s.type?.type_name || s.type) === this.selectedCandidateType &&
              new Date(s.endDate) > new Date()
          );

          if (voteStillOpen) {
            return Swal.fire("Not Allowed", "Vote event for this candidate type is still open. You can't open Result yet.", "error");
          }

        } catch (err) {
          console.error("Error checking vote events", err);
          return Swal.fire("Error", "Unable to verify event conditions. Try again.", "error");
        }
      }

      // ✅ Proceed if all checks passed
      const payload = {
        event_name: this.selectedEvent,
        type_name: this.selectedCandidateType,
        startDate: this.startDate,
        endDate: this.endDate
      };

      try {
        const response = await api.setter("post", payload);
        Swal.fire("Success", "Time set!", "success");
        console.log("Created setter:", response.data.data);
      } catch (error) {
        console.error("Error setting time:", error);
        const msg = error.response?.data?.error || "Unknown error";
        Swal.fire("Error", msg, "error");
      }
    }
  }
};
</script>